import type { LoginRadiusStore } from "@/ts/types";
import { devtools } from "zustand/middleware";
import { subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { createStore } from "zustand/vanilla";
export const initialState = {
    email: undefined,
};
export const loginRadiusStore = createStore<LoginRadiusStore>()(devtools(subscribeWithSelector(immer((_set, _get) => ({
    ...initialState,
}))), {
    name: "Hydra-LoginRadiusStore",
}));
